import { useState, useEffect } from 'react';
// import Debugger from './archive/debugger';
import ChatWindow from './chat-window';

const LLMAnimation = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setStep(3);
    }, 1000);
  }, []);

  useEffect(() => {
    if (step === 2) {
      setStep(3);
    }
  });

  return (
    <div className="flex flex-col justify-center">
      <ChatWindow step={step} setStep={setStep} />
      {/* <Debugger step={step} setStep={setStep} /> */}
    </div>
  );
};

export default LLMAnimation;
